import '@splidejs/splide/dist/css/splide.min.css';

import Splide from '@splidejs/splide';

const Testimonial = () => {
  const testimonialList = document.querySelector('.js-testimonialList');

  if (!testimonialList) return;

  const CONFIG_SPLIDE = {
    arrows: false,
    pagination: true,
    drag: true,
    perPage: 1,
    perPane: 1,
    autoHeight: true
  };

  if (document.querySelector(`#tb-blockTestimonial`)) {
    const splide = new Splide(`#tb-blockTestimonial`, CONFIG_SPLIDE);
    splide.mount();
  }
};

export default Testimonial;
